"use strict";
// from modernizr according to http://davidwalsh.name/css-animation-callback
var t;
var el = document.createElement('fakeelement');
var transitions = {
    'transition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'MozTransition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd'
};

for (t in transitions) {
    if (el.style[t] !== undefined) {
        module.exports = transitions[t];
        break;
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/libraries/whichTransitionEndEvent.js
// module id = 692
// module chunks = 4 6 7 8 9 13 17